<app-social-shell active="notifications">
  <div class="so-page-head">
    <div>
      <h1>Notifications</h1>
      <p>Likes, comments, follows, invites and what's happening in your groups.</p>
    </div>
    <div class="so-head-actions">
      <div class="so-chips" role="group" aria-label="Show">
        <button type="button" [class.is-on]="filter === 'all'" (click)="filter = 'all'">All</button>
        <button type="button" [class.is-on]="filter === 'unread'" (click)="filter = 'unread'">Unread</button>
      </div>
      <button type="button" class="btn btn-dark" [disabled]="!unread" (click)="markAll()">Mark all read</button>
    </div>
  </div>

  <div class="so-card">
    @if (loading) {
      @for (s of [1, 2, 3, 4]; track s) {
        <div class="so-row"><span class="so-avatar so-skel"></span><span class="so-skel" style="flex: 1; height: 14px"></span></div>
      }
    } @else if (failed) {
      <div class="so-empty">
        <h3>Couldn't load notifications</h3>
        <button type="button" class="btn btn-theme" (click)="load()">Try again</button>
      </div>
    } @else if (!shown.length) {
      <div class="so-empty">
        <span class="so-empty-icon"><i class="fa fa-bell-o"></i></span>
        <h3>{{ filter === 'unread' ? "You're all caught up" : 'No notifications yet' }}</h3>
        <p>When people like, comment, follow you or invite you somewhere, it shows up here.</p>
      </div>
    } @else {
      <ul class="so-list">
        @for (n of shown; track n.id) {
          <li>
            <button type="button" class="nt-item" [class.is-unread]="!n.is_read" (click)="open(n)">
              <span class="nt-avatar">
                <span class="so-avatar">
                  @if (avatar(n)) { <img [src]="avatar(n)" alt="" /> } @else { {{ initials(n.actor?.name) || '•' }} }
                </span>
                <span class="nt-kind"><i class="fa" [ngClass]="icon(n)"></i></span>
              </span>
              <span class="nt-text">{{ n.message }}</span>
              <span class="nt-time">{{ timeAgo(n.created_at) }}</span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
  @if (hasMore && !loading) {
    <button type="button" class="so-more" style="margin-top: 14px" [disabled]="loadingMore" (click)="load(true)">{{ loadingMore ? 'Loading…' : 'Load older' }}</button>
  }
</app-social-shell>
